import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import FocusAreas from "@/pages/FocusAreas";
import EthicalAI from "@/pages/EthicalAI";
import Frameworks from "@/pages/Frameworks";
import SDGs from "@/pages/SDGs";
import Insights from "@/pages/Insights";
import Partnerships from "@/pages/Partnerships";
import Resources from "@/pages/Resources";
import GetInvolved from "@/pages/GetInvolved";
import ForesightObservatory from "@/pages/ForesightObservatory";
import ExecutiveEducation from "@/pages/ExecutiveEducation";
import Media from "@/pages/Media";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Accessibility from "@/pages/Accessibility";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/focus-areas" element={<FocusAreas />} />
          <Route path="/ethical-ai" element={<EthicalAI />} />
          <Route path="/frameworks" element={<Frameworks />} />
          <Route path="/sdgs" element={<SDGs />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/foresight" element={<ForesightObservatory />} />
          <Route path="/executive-education" element={<ExecutiveEducation />} />
          <Route path="/media" element={<Media />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/accessibility" element={<Accessibility />} />
          {/* Fallback */}
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
